const shoesData = [
  {
    id: 1,
    brand: "PF. Flyers",
    photoName: "shoes/shoe1.webp",
    name: "PF. Flyers Hi Top",
    price: 69.9,
    discount: 0,
    sizes: [8, 8.5, 9, 9.5, 10, 10.5, 11],
    quantity: 1,
  },
  {
    id: 2,
    brand: "Nike",
    photoName: "shoes/shoe2.webp",
    name: "Nike Air Force",
    price: 99.9,
    discount: 0,
    sizes: [7, 8.5, 9, 9.5, 10, 10.5],
    quantity: 1,
  },
  {
    id: 3,
    brand: "Jordan",
    photoName: "shoes/shoe3.webp",
    name: "Jordan Retro XIII",
    price: 119.9,
    discount: 0,
    sizes: [8.5, 9, 10, 10.5, 11, 12],
    quantity: 1,
  },
  {
    id: 4,
    brand: "Jordan",
    photoName: "shoes/shoe4.webp",
    name: "Jordan Retro III",
    price: 129.9,
    discount: 0,
    sizes: [7, 7.5, 9, 9.5, 10.5, 11.5],
    quantity: 1,
  },
  {
    id: 5,
    brand: "Jordan",
    photoName: "shoes/shoe5.webp",
    name: "Jordan Retro I",
    price: 109.9,
    discount: 0,
    sizes: [6, 7.5, 9, 9.5, 10, 10.5],
    quantity: 1,
  },
  {
    id: 6,
    brand: "Nike",
    photoName: "shoes/shoe6.webp",
    name: "Nike Air Max 95",
    price: 89.9,
    discount: 0,
    sizes: [6, 6.5, 7, 8, 9.5, 10],
    quantity: 1,
  },
];

export default shoesData;
